import { Accordion } from '@3pc/accordion';

const quicklinksEls = document.querySelectorAll('.page-quicklinks');
const quicklinksInstances = [];

quicklinksEls.forEach(quicklinks => {
  const target = quicklinks.querySelector('.page-quicklinks__content');
  const targetInner = quicklinks.querySelector(
    '.page-quicklinks__content-inner'
  );
  const handler = quicklinks.querySelector('.page-quicklinks__toggle');

  const quicklinksInstance = new Accordion({
    target,
    targetInner,
    handler,
  });

  quicklinksInstance.init();
  quicklinksInstances.push(quicklinksInstance);
});
